import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';

import combineStyles from '../../utils/combineStyles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';

import SummaryCard from './SummaryCard';

const styles = () => ({
  rowCardWrapper: {
    width: 'calc(50% - 12px)'
  }
});

export const Header = ({
  t,
  classes,
  incompleteShipmentCounter,
  waitingForPickupShipmentCounter,
  inTransitShipmentCounter,
  delayedShipmentCounter,
  totalShipmentCounter,
  theme
}) => (
  <div className={classes.row}>
    <div className={classnames(classes.rowCardWrapper, classes.row)}>
      <div className={classes.rowCardWrapper}>
        <SummaryCard
          totalCount={incompleteShipmentCounter}
          message={t('Incomplete Shipments')}
          ProgressBarProps={{
            color: '#F22D12',
            totalValue: totalShipmentCounter,
            value: incompleteShipmentCounter,
            resourceType: t('Shipments')
          }}
        />
      </div>
      <div className={classes.rowCardWrapper}>
        <SummaryCard
          totalCount={waitingForPickupShipmentCounter}
          message={t('Waiting for Pickup')}
          ProgressBarProps={{
            color: theme.palette.primary.main,
            totalValue: totalShipmentCounter,
            value: waitingForPickupShipmentCounter,
            resourceType: t('Shipments')
          }}
        />
      </div>
    </div>
    <div className={classnames(classes.rowCardWrapper, classes.row)}>
      <div className={classes.rowCardWrapper}>
        <SummaryCard
          totalCount={inTransitShipmentCounter}
          message={t('In Transit Shipments')}
          ProgressBarProps={{
            color: '#FEB00B',
            totalValue: totalShipmentCounter,
            value: inTransitShipmentCounter,
            resourceType: t('Shipments')
          }}
        />
      </div>
      <div className={classes.rowCardWrapper}>
        <SummaryCard
          totalCount={delayedShipmentCounter}
          message={t('Delayed Shipments')}
          ProgressBarProps={{
            color: '#F22D12',
            totalValue: totalShipmentCounter,
            value: delayedShipmentCounter,
            resourceType: t('Shipments')
          }}
        />
      </div>
    </div>
  </div>
);

const HeaderWithTranslations = withNamespaces()(Header);
export default withStyles(
  combineStyles(TypographyStyles, LayoutStyles, styles),
  {
    withTheme: true
  }
)(HeaderWithTranslations);
